import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import api from "../../../utils/api";
// import StateAuditLogDropdown from "./StateAusss

export default function UserMetaChangeLogModal(props) {
	const renderFields = () => {
		let fields = [];

		if (props.userMetaChangeLogData && props.userMetaChangeLogData.length) {
			fields = props.userMetaChangeLogData.map((e) => {
				return (
					<tr>
						<td>{e["change_type"]}</td>
						<td>{e["new_data"]}</td>

						<td>{e["old_data"]}</td>
						<td>{e["updated_by"]}</td>

						<td>{e["update_date"]}</td>
					</tr>
				);
			});
		}
		return fields;
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<div className="p-2 modals-headers-bar">
					<span>User Meta Change Log </span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X style={{ pointerEvents: "none" }} color="white" />
					</button>
				</div>
				<div
					className="modal-body"
					style={{
						overflowY: "scroll",
						height: "400px",
					}}
				>
					{renderFields().length !== 0 ? (
						<table>
							<tr>
								<th>Change Type</th>
								<th>New Data</th>
								<th>Old Data</th>
								<th>Updated By</th>
								<th>Updated Date</th>
							</tr>
							{renderFields()}
						</table>
					) : (
						<span>No data to show</span>
					)}
				</div>
			</ModalContent>
		</Modal>
	);
}
